import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { posts } from "../data/blog";

const BlogPost = () => {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) return <Navigate to="/blog" replace />;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28" data-testid="blog-post-page">
      <Helmet>
        <title>{`${post.title} | Ишеевские пироги`}</title>
        <meta name="description" content={post.excerpt} />
        <link rel="canonical" href={`https://pirogi73.ru/blog/${post.slug}/`} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.excerpt} />
        <meta property="og:image" content={`https://pirogi73.ru${post.image}`} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://pirogi73.ru/blog/${post.slug}/`} />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": post.title,
          "description": post.excerpt,
          "image": `https://pirogi73.ru${post.image}`,
          "datePublished": post.date,
          "publisher": {
            "@type": "Organization",
            "name": "Ишеевские пироги",
            "url": "https://pirogi73.ru"
          }
        })}</script>
      </Helmet>
      <Link to="/blog" className="label-eyebrow hover:text-[#C65D3B] transition-colors mb-8 inline-block">
        ← Блог
      </Link>

      <div className="label-eyebrow mb-4">{post.date}</div>
      <h1 className="font-display text-4xl sm:text-5xl text-[#2C2520] leading-tight mb-10">
        {post.title}
      </h1>

      {post.image && (
        <div className="rounded-[24px] overflow-hidden mb-12">
          <img src={post.image} alt={post.title} className="w-full object-cover" />
        </div>
      )}

      <div className="prose-custom space-y-5 text-[#5C4F45] text-lg leading-relaxed">
        {post.content.map((block, i) => {
          if (block.type === "html") {
            return <p key={i} className="text-[#5C4F45]" dangerouslySetInnerHTML={{ __html: block.html }} />;
          }
          if (block.type === "internalLink") {
            return (
              <div key={i} className="my-6">
                <a
                  href={block.href}
                  className="inline-flex items-center gap-3 px-6 py-4 rounded-[16px] bg-[#F2EBE1] border border-[#E8E3DA] hover:border-[#C65D3B] hover:bg-[#EDE5D8] transition-colors text-[#2C2520] font-medium text-base"
                >
                  <span className="text-[#C65D3B]">→</span>
                  {block.text}
                </a>
              </div>
            );
          }
          if (block.type === "heading") {
            return (
              <h2 key={i} className="font-display text-2xl text-[#2C2520] mt-10 mb-2">
                {block.text}
              </h2>
            );
          }
          if (block.type === "list") {
            return (
              <ul key={i} className="space-y-2 pl-5">
                {block.items.map((item, j) => (
                  <li key={j} className="flex gap-2">
                    <span className="text-[#C65D3B] mt-1.5">·</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            );
          }
          return <p key={i}>{block.text}</p>;
        })}
      </div>

      <div className="mt-16 pt-10 border-t border-[#E8E3DA] text-center">
        <Link to="/" className="btn-primary">
          Заказать пироги →
        </Link>
      </div>
    </div>
  );
};

export default BlogPost;
